// extracted by mini-css-extract-plugin
export var container = "_bn-1";
export var cornerButtonContainer = "_bn-5";
export var disabled = "_bn-2";
export var fileContainer = "_bn-4";
export var hiddenInput = "_bn-3";
export var widthContainer = "_bn-0";